import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import clsx from 'clsx';
import selectPageSectionCSS from '../selectors/page-section-css';
import { mediaBreakpointUpLG, mediaBreakpointUpMD } from '../constants/style-constants';
import { vunit } from '../lib/style-helpers';

const PageSectionCSS = ({ textColor, backgroundCSS, paddingCSS }) => css`
  color: ${textColor};
  position: relative;
  padding: ${vunit(4)} 0;

  ${mediaBreakpointUpMD} {
    padding: ${vunit(6)} 0;
  }

  ${mediaBreakpointUpLG} {
    padding: ${vunit(8)} 0;
  }

  hr {
    background-color: ${textColor};
  }

  h1, h2, h3, h4 {
    color: ${textColor};
  }

  strong {
    font-weight: bold;
  }

  ${backgroundCSS}
  ${paddingCSS}
`;

const PageSection = ({
  children, theme, className, ...rest
}) => (
  <section className={clsx(className, `page-section--${theme}`)} css={PageSectionCSS(selectPageSectionCSS(theme))} {...rest}>
    <div className="container">
      {children}
    </div>
  </section>
);

PageSection.defaultProps = {
  theme: 'default',
  className: undefined,
};

PageSection.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.string,
  className: PropTypes.string,
};

export default PageSection;
